/**
 * Single source of truth for the DB-backed fields the deal Details tab renders
 * as inline (click-to-edit) `FieldRow`s.
 *
 * Kept in its own module (no React/component imports) so the field-placement
 * coverage test can import the list without pulling in the whole component tree.
 * The coverage guard (tests/crm-entities/entity-field-placement-coverage.test.ts)
 * treats these as an edit surface, so a real editable column shown here counts as
 * "placed" and every id here must be an editable real column.
 *
 * Per product decision, the value/pipeline fields (revenue, monthly_amount,
 * close_probability, close_date) are ALSO edited in the modal header — duplicate
 * editors are intentionally allowed here so each is editable where the user looks.
 */

/** Fields rendered in the "Deal Details" collapsible section, in display order. */
export const DEAL_DETAIL_SECTION_FIELD_IDS = [
  "revenue",
  "monthly_amount",
  "close_probability",
  "close_date",
  "is_recurring",
  "is_committed",
  "cost",
  "estimated_hours",
  "contract_term_months",
  "currency",
] as const;

/** Every DB-backed field the deal Details tab renders as an inline editor. */
export const DEAL_DETAIL_TAB_EDITABLE_FIELD_IDS = [
  "description",
  "company_id",
  ...DEAL_DETAIL_SECTION_FIELD_IDS,
  "notes",
] as const;
